export const Types = {
    GET_BREAKDOWN_EFFECTS: "GET_BREAKDOWN_EFFECTS",
    SET_BREAKDOWN_EFFECTS: "SET_BREAKDOWN_EFFECTS",
    ADD_BREAKDOWN_EFFECT: "ADD_BREAKDOWN_EFFECT",
    UPDATE_BREAKDOWN_EFFECT: "UPDATE_BREAKDOWN_EFFECT",
    DELETE_BREAKDOWN_EFFECT: "DELETE_BREAKDOWN_EFFECT",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getBreakdownEffects = () => {
    return {
        type: Types.GET_BREAKDOWN_EFFECTS,
    };
};

export const setBreakdownEffects = (payload) => {
    return {
        type: Types.SET_BREAKDOWN_EFFECTS,
        payload: payload,
    };
};

export const addBreakdownEffect = (payload) => {
    return {
        type: Types.ADD_BREAKDOWN_EFFECT,
        payload: payload,
    };
};

export const updateBreakdownEffect = (payload) => {
    return {
        type: Types.UPDATE_BREAKDOWN_EFFECT,
        payload: payload,
    };
};

export const deleteBreakdownEffect = (payload) => {
    return {
        type: Types.DELETE_BREAKDOWN_EFFECT,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
